import createDuck, {createAction, createThunk} from '../utils/actions';
import axios from '../net/axios';
import config from '../config';

const baseUrl = config.api.baseUrl;

const usuariosGetDuck = createDuck('USUARIOS_GET');

const usuariosGetThunk = params => {
  const url = `${baseUrl}/v1/usuarios`;
  return createThunk(axios, 'get', usuariosGetDuck.actions, url, null, params);
};

const usuarioGetDuck = createDuck('USUARIO_GET');

const usuarioGetThunk = params => {
  const url = `${baseUrl}/v1/usuario`;
  return createThunk(axios, 'get', usuarioGetDuck.actions, url, null, params);
};

const usuarioAddDuck = createDuck('USUARIO_ADD');

const usuarioAddThunk = data => {
  const url = `${baseUrl}/signup`;
  return createThunk(axios, 'post', usuarioAddDuck.actions, url, data);
};

const usuarioEditDuck = createDuck('USUARIO_EDIT');

const usuarioEditThunk = params => {
  const url = `${baseUrl}/v1/usuario`;
  return createThunk(axios, 'patch', usuarioEditDuck.actions, url, params);
};

export {
  usuariosGetDuck,
  usuariosGetThunk,
  usuarioGetDuck,
  usuarioGetThunk,
  usuarioEditDuck,
  usuarioEditThunk,
  usuarioAddDuck,
  usuarioAddThunk,
};
